import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Children } from 'react';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';
import { FacebookShareInterstitial } from './facebook-share/FacebookShareInterstitial';

const isTeacher = () => window.getUserType() === 'teacher';

const selfPromotionClipboardText = "I'm trying to bring more resources to my classroom to help my students thrive." +
    " If you're looking for a simple way to support my class, this is it. \u{D83D}\u{DC9B}";
const generalClipboardText = 'Teachers need the right tools to help their students excel.' +
    " If you're looking for a simple way to support public schools, this is it!";

/* global dcAnalytics */
export const FacebookLink = createReactClass({
    propTypes: {
        urlToShare: PropTypes.string.isRequired,
        pageName: PropTypes.string,
        projectId: PropTypes.number,

        getTrackingLink: PropTypes.func.isRequired,
        facebookAppId: PropTypes.string.isRequired,

        onFacebookClick: PropTypes.func,
        fulfillmentTrailer: PropTypes.string,
        projectSummary: PropTypes.string,
        useSpan: PropTypes.bool,
        className: PropTypes.string,
        closeAfterShare: PropTypes.bool,
        essentialsListShare: PropTypes.bool,
        skipClipboard: PropTypes.bool,

        children: PropTypes.node,
    },

    getInitialState: function () {
        return {
            showInterstitial: false,
        };
    },

    getDefaultProps: function () {
        return {
            closeAfterShare: false,
        };
    },

    getFacebookUrl: function () {
        const trackingLink = this.props.getTrackingLink(this.props.urlToShare, 'facebook', this.props.pageName);
        return 'https://www.facebook.com/dialog/share?app_id=' + this.props.facebookAppId +
                '&display=popup&href=' + trackingLink + (this.props.closeAfterShare ? '' : '&redirect_uri=' + trackingLink);
    },

    shareIcon: function () {
        if (Children.count(this.props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="ss-facebook" iconFamily="social-circle"/>
            );
        }
    },

    onClick(event) {
        event.preventDefault();
        event.stopPropagation();

        dcAnalytics.trackShareToolClick(this.props.pageName, this.props.urlToShare, 'Facebook', this.props.essentialsListShare);
        trackShareToolClick(this.props.projectId, SHARE_TOOLS.FACEBOOK);

        if (!this.props.skipClipboard && isTeacher()) {
            const clipboard = window.teacherId === window.userId ? selfPromotionClipboardText : generalClipboardText;
            navigator.clipboard.writeText(clipboard).then(() => this.setState({ showInterstitial: true }));
        }
        const windowFeatures = 'width=500,height=350,resizable=yes,scrollbars=yes,status=yes';

        const delay = isTeacher() ? 3000 : 0;
        setTimeout(() => window.open(this.getFacebookUrl(), '_blank', windowFeatures), delay);

        if (this.props.onFacebookClick) {
            return this.props.onFacebookClick(event, this.getFacebookUrl());
        }
    },

    render: function () {
        return <>
            {this.props.useSpan
                ? <KeyboardClickable>
                    <a className={this.props.className + ' button-secondary small  heap-facebook-share'}
                        aria-label="Share on Facebook"
                        data-title="Share on Facebook"
                        target="_blank"
                        onClick={this.onClick}
                        rel="noreferrer"
                        href={this.getFacebookUrl()}>
                        {this.shareIcon()}
                        {this.props.children}
                    </a>
                </KeyboardClickable>
                : <a className={this.props.className + ' button-secondary small  heap-facebook-share'}
                    aria-label="Share on Facebook"
                    data-title="Share on Facebook"
                    target="_blank"
                    onClick={this.onClick}
                    rel="noreferrer"
                    href={this.getFacebookUrl()}>
                    {this.shareIcon()}
                    {this.props.children}
                </a>}
            <FacebookShareInterstitial
                show={this.state.showInterstitial}
                hide={() => this.setState({ showInterstitial: false })}
                facebookLink={this.getFacebookUrl()} />
        </>;
    },
});
